import { Label } from "reactstrap";
import TableComponent from "../../../components/TableComponent";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { RETAIL_APPLICATION_HEADERS } from "../DashboardHelper";

const RetailApplicationDetails = (props: any) => {
    const {
        storeCustomerDetailsSearchData,
    } = useSelector((state: any) => state.grievances);
    let tableData = storeCustomerDetailsSearchData?.data ?? []

    return (
        <>
            <Label>
                <img 
                    src={require('../../../assets/img/Back.svg').default} 
                    style={{marginRight:'15px', cursor: 'pointer'}}
                    onClick={() => {
                        props?.setSearchSection(!props?.searchSection);
                        props?.setRetailApplicationTable(false);
                    }}
                />
                {props?.getValues('searchMobile') && <span>Mobile Number: {props?.getValues('searchMobile')}</span>}
                {props?.getValues('searchPolicy') && <span>Policy Number: {props?.getValues('searchPolicy')}</span>}
            </Label>
            <div className="table-container">
                <TableComponent 
                    data={tableData}
                    columnHeaders={RETAIL_APPLICATION_HEADERS}
                    onAction={props?.onTableAction}
                    responsive={false}
                />
            </div>
        </>
    );
}

export default RetailApplicationDetails;